module.exports = __webpack_public_path__ + "img/money-popup-icon-wx.2b475b38.png";